import { createSelector } from '@reduxjs/toolkit'
import type { Themes } from '@shared-core/features/config/models/types'
import { defaultLocale, type Localization, localizations } from '@shared-core/features/settings/configs/localizations'
import type { AppState } from '@shared-core/store/types'

import { storeKey } from './slice'

const selectSettingsState = (state: AppState) => state[storeKey]

export const selectedLanguage = createSelector(selectSettingsState, (state) => state.language || localizations[0].code)
export const selectedDefaultLanguageObject = createSelector(
  () => localizations.find((item) => item.isDefault)?.code || defaultLocale,
)
export const selectedUserThemePalette = createSelector(selectSettingsState, (state) => state.theme as Themes)
export const selectedUserPhone = createSelector(selectSettingsState, (state) => state.phone || '')
export const selectedCurrentLanguageObject = createSelector(
  selectedLanguage,
  (lang) => localizations.find((item) => item.code === lang) as Localization,
)

export const selectedIsHiddenBalance = createSelector(selectSettingsState, (state) => state.isHideBalance || false)
export const selectedIsVibrationEnabled = createSelector(
  selectSettingsState,
  (state) => state.isVibrationEnabled ?? true,
)
export const selectedIsDevMode = createSelector(selectSettingsState, (state) => {
  return state.developerMode || false
})
export const selectedApiDelayMs = createSelector(selectSettingsState, (state) => state.apiDelayMs ?? 0)
export const selectedApiErrorRate = createSelector(selectSettingsState, (state) => state.apiErrorRate ?? 0)
export const selectedApiBaseUrlOverride = createSelector(selectSettingsState, (state) => state.apiBaseUrlOverride ?? '')
export const selectedApiMockBaseUrl = createSelector(selectSettingsState, (state) => state.apiMockBaseUrl ?? '')
